import { handleErrors, HttpStatusError } from "../util/api-utils";
import { logError } from "./logger-configuration";

/**
 * Saves the updated agency branch section of the agency profile.
 * @param {any} agencyProfile The updated agency profile.
 * @param {function} successCallback The success callback function.
 * @param {function} finallyCallback The finally callback function.
 */
export function updateAgencyBranch(agencyProfile, successCallback, finallyCallback) {
    fetch("api/AgencyProfile/UpdateAgencyBranch", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(agencyProfile)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error)
        .finally(finallyCallback);
};

/**
 * Saves the updated additional information section of the agency profile.
 * @param {any} agencyProfile The updated agency profile.
 * @param {function} successCallback The success callback function.
 * @param {function} finallyCallback The finally callback function.
 */
export function updateAdditionalInformation(agencyProfile, successCallback, finallyCallback) {
    fetch("api/AgencyProfile/UpdateAdditionalInformation", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(agencyProfile)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error)
        .finally(finallyCallback);
};

/**
 * Saves the updated errors and omissions section of the agency profile.
 * @param {any} agencyProfile The updated agency profile.
 * @param {function} successCallback The success callback function.
 * @param {function} finallyCallback The finally callback function.
 */
export function updateErrorsAndOmissions(agencyProfile, successCallback, finallyCallback) {
    fetch("api/AgencyProfile/UpdateErrorsAndOmissions", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(agencyProfile)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error)
        .finally(finallyCallback);
};

/**
 * Saves the updated quote and policy management systems section of the agency profile.
 * @param {any} agencyProfile The updated agency profile.
 * @param {function} successCallback The success callback function.
 * @param {function} finallyCallback The finally callback function.
 */
export function updateQuoteAndPolicyManagementSystems(agencyProfile, successCallback, finallyCallback) {
    fetch("api/AgencyProfile/UpdateQuoteAndPolicyManagementSystems", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(agencyProfile)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error)
        .finally(finallyCallback);
};

/**
 * Gets an agency profile by ID.
 * @param {string} agencyId The ID of the agency to get.
 * @param {function} successCallback The success callback function.
 */
export function getAgencyProfile(agencyId, successCallback) {
    fetch("api/AgencyProfile/Get", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(agencyId)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
    ;
}

/**
 * Gets an agency profile by ID.
 * @param {string} agencyId The ID of the agency to get.
 * @param {function} successCallback The success callback function.
 */
export function getAgencyProfileForSweeps(agencyId, successCallback, errorCallback) {
    fetch("api/AgencyProfile/GetAgencyProfileForSweeps?agencyId=" + agencyId, {
        method: "get",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);

}

/**
 * Saves the updated sweep details section of the agency profile.
 * @param {any} agencyProfile The updated agency profile.
 * @param {function} successCallback The success callback function.
 * @param {function} finallyCallback The finally callback function.
 */
export function updateSweepDetails(agencyProfile, successCallback, finallyCallback) {
    fetch("api/AgencyProfile/UpdateSweepDetails", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(agencyProfile)
    })
        .then((result => customHandleErrors(result, "UpdateSweepDetails")))
        .then(successCallback)
        .catch(console.error)
        .finally(finallyCallback);
};

export function publishSweepEventToBlob(publishSweepEventRequest, successCallback, finallyCallback) {
    fetch("api/AgencyProfile/PublishSweepEventToBlob", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(publishSweepEventRequest)
    })
        .then((result => customHandleErrors(result, "PublishSweepEventToBlob")))
        .then(successCallback)
        .catch(console.error)
        .finally(finallyCallback);
};

/**
 * Saves the updated taxInfoOnFile of the agency profile.
 * @param {any} agencyProfile The updated agency profile.
 * @param {function} successCallback The success callback function.
 * @param {function} finallyCallback The finally callback function.
 */
export function updateTaxInfoOnFile(agencyProfile, successCallback, finallyCallback) {
    fetch("api/AgencyProfile/UpdateTaxInfoOnFile", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(agencyProfile)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error)
        .finally(finallyCallback);
};

/**
 * Delete the sweeps account of the agency profile.
 * @param {any} agencyProfile The updated agency profile.
 * @param {function} successCallback The success callback function.
 * @param {function} finallyCallback The finally callback function.
 */
export function deleteSweepDetails(agencyProfile, successCallback, finallyCallback) {

    fetch("api/AgencyProfile/DeleteSweepAccount", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(agencyProfile)
    })
        .then((result => customHandleErrors(result, "DeleteSweepDetails")))
        .then(successCallback)
        .catch(console.error)
        .finally(finallyCallback);
};

/** 
 * Get the vault api bearer token.
 * @param {function} successCallback The success callback function.
 */
export function getVaultApiBearerToken(successCallback) {
    fetch("api/AgencyProfile/GetBearerToken", {
        method: "get",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
}

export function getFeatureAccessRetrieve(featureName, successCallback, errorCallback) {
    fetch("api/AgencyProfile/GetFeatureAccessRetrieve?featureName=" + featureName, {
        method: "get",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}
async function customHandleErrors(response, apiName) {

    const bodyText = await response.text();

    const body = (() => {
        try {
            return JSON.parse(bodyText);
        }
        catch {
            return bodyText;
        }
    })();

    // Check for FluentValidations errors.
    if (body?.isValid === false && body.errors) {
        logError("FluentValidations error: " + JSON.stringify(body.errors, null, 4));
        throw new Error(JSON.stringify(body.errors, null, 4), response);
    }

    // Check for HTTP error codes.
    if (!response.ok) {
        logError(`${apiName} error: ${response.statusText} - ${JSON.stringify(body)}`);
        throw new HttpStatusError(response.statusText, response, body);
    }

    return body;
}